import { useState } from 'react';
import { saveContact, deleteContact as delContact } from '../../api';

const ROLES = [
  { value: 'DUTY_HOLDER', label: 'Duty Holder' },
  { value: 'RESPONSIBLE_PERSON', label: 'Responsible Person' },
  { value: 'DEPUTY', label: 'Deputy' },
  { value: 'ENGINEERING_MAINTENANCE', label: 'Engineering Maintenance' },
  { value: 'WATER_TREATMENT_CONTRACTOR', label: 'Water Treatment Contractor' },
];
const roleLabel = (val) => ROLES.find((r) => r.value === val)?.label || (val || '').replace(/_/g, ' ');
const EMPTY = { role: 'DUTY_HOLDER', contactName: '', jobTitle: '', address: '', telephone: '', email: '' };

export default function ContactsTab({ report, onSave, readOnly = false }) {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [msg, setMsg] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const startNew = () => { setEditing('new'); setForm(EMPTY); };
  const startEdit = (c) => { setEditing(c.id); setForm({ ...c }); };
  const cancel = () => { setEditing(null); setForm(EMPTY); };

  const handleSave = async () => {
    try {
      await saveContact(report.id, { ...form, id: editing === 'new' ? null : editing, sortOrder: (report.contacts || []).length });
      setEditing(null);
      setForm(EMPTY);
      setMsg('Saved');
      onSave();
      setTimeout(() => setMsg(''), 2000);
    } catch (err) { setMsg(err.message); }
  };

  const handleDelete = async (id) => { if (!window.confirm('Delete this contact?')) return; await delContact(id); onSave(); };

  return (
    <div>
      {msg && <div className="alert alert-success">{msg}</div>}
      {!readOnly && <button className="btn btn-primary" onClick={startNew} style={{ marginBottom: '1rem' }}>Add Contact</button>}

      {!readOnly && editing && (
        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: '1rem', marginBottom: '1rem', background: '#fafafa' }}>
          <div className="form-row">
            <div className="form-group">
              <label>Role</label>
              <select name="role" value={form.role} onChange={handleChange}>
                {ROLES.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Name</label><input name="contactName" value={form.contactName} onChange={handleChange} /></div>
            <div className="form-group"><label>Job Title</label><input name="jobTitle" value={form.jobTitle} onChange={handleChange} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Address</label><input name="address" value={form.address} onChange={handleChange} /></div>
            <div className="form-group"><label>Telephone</label><input name="telephone" value={form.telephone} onChange={handleChange} /></div>
            <div className="form-group"><label>Email</label><input name="email" value={form.email} onChange={handleChange} /></div>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button className="btn btn-primary" onClick={handleSave}>Save</button>
            <button className="btn btn-outline" style={{ color: '#333', borderColor: '#ccc' }} onClick={cancel}>Cancel</button>
          </div>
        </div>
      )}

      <div className="table-scroll">
        <table className="data-table">
          <thead><tr><th>Role</th><th>Name</th><th>Job Title</th><th>Telephone</th><th>Email</th>{!readOnly && <th></th>}</tr></thead>
          <tbody>
            {(report.contacts || []).map((c) => (
              <tr key={c.id}>
                <td>{roleLabel(c.role)}</td>
                <td>{c.contactName}</td>
                <td>{c.jobTitle}</td>
                <td>{c.telephone}</td>
                <td>{c.email}</td>
                {!readOnly && <td>
                  <button onClick={() => startEdit(c)} style={{ cursor: 'pointer', border: 'none', background: 'none', color: '#4361ee' }}>Edit</button>
                  <button onClick={() => handleDelete(c.id)} style={{ cursor: 'pointer', border: 'none', background: 'none', color: '#dc2626', marginLeft: 8 }}>Del</button>
                </td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
